module.exports = __webpack_public_path__ + "img/f6-2.d8c27db3.png";